import { forwardRef } from "react";
import { closeSnackbar, type CustomContentProps, type VariantType } from "notistack";
import { Snackbar, type SnackbarVariant } from "./Snackbar";

type QueuedSnackbarProps = CustomContentProps & {
  subtitle?: string;
  close?: boolean;
};

function mapVariant(variant: VariantType): SnackbarVariant {
  if (variant === "error" || variant === "warning" || variant === "info") {
    return variant;
  }

  return "success";
}

function headlineFromMessage(message: CustomContentProps["message"]): string {
  if (typeof message === "string") {
    return message;
  }

  if (typeof message === "number") {
    return String(message);
  }

  return "";
}

export const QueuedSnackbar = forwardRef<HTMLDivElement, QueuedSnackbarProps>(function QueuedSnackbar(
  { id, message, variant, action, subtitle, close = true },
  ref
) {
  return (
    <Snackbar
      ref={ref}
      message={headlineFromMessage(message)}
      subtitle={subtitle}
      variant={mapVariant(variant)}
      actions={typeof action === "function" ? action(id) : action}
      close={close}
      onClose={() => {
        closeSnackbar(id);
      }}
    />
  );
});

export const snackbarProviderComponents = {
  default: QueuedSnackbar,
  error: QueuedSnackbar,
  info: QueuedSnackbar,
  success: QueuedSnackbar,
  warning: QueuedSnackbar
};
